// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contact-us-box[data-v-5b51bf7c]{\n  text-align: center;\n}\nh6[data-v-5b51bf7c]{\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
